import React, {forwardRef, useState} from 'react';
import useStyles from './Styles';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent, DialogContentText,
    IconButton,
    Typography,
    Zoom
} from "@material-ui/core";
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import InputField from "./InputField";

const Transition = forwardRef(function Transition(props, ref) {
    return <Zoom in={props.open} ref={ref} {...props}/>;
});

const DialogTitle = ({children, handleClose, ...props}) => (
    <MuiDialogTitle disableTypography {...props} style={{ display: 'flex', justifyContent: 'space-between'}}>
        <Typography variant='h6'>{children}</Typography>
        {handleClose &&
        <IconButton onClick={handleClose} size="small">
            X
        </IconButton>}
    </MuiDialogTitle>
);

export default function AlertDialogSlide({open, title, description , handleClose, handleSubmit, nameInputSets}){
    const classes = useStyles();
    const nameValue = typeof nameInputSets.value !== undefined ? nameInputSets.value : '';
    const [renameText, setRenameText] = useState(nameValue);

    const handleNameChange = value => {
        setRenameText(value);
        nameInputSets.callBack(value);
    };

    return (
        <Dialog open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                className='dialogBlock'>
            <DialogTitle className='dialogtitle' handleClose={handleClose}> {title} </DialogTitle>

            <DialogContent>
                <DialogContentText>
                    <div className={classes.dialogDescription} dangerouslySetInnerHTML={{ __html: description }}/>
                </DialogContentText>
                {nameInputSets.value &&
                <div className='form-group'>
                    <InputField
                        type='text'
                        label={nameInputSets.label}
                        onChange={handleNameChange}
                        value={renameText}
                        variant='outlined'
                    />
                </div>
                }
            </DialogContent>
            <DialogActions className="dialogButtons">
                {handleSubmit && <Button onClick={handleSubmit} size="small" variant="outlined" color="primary">Submit</Button>}
            </DialogActions>
        </Dialog>
    )

}